import { DI } from '@intigral/constant/config/DIContainer';
import { Container } from '../../DIContainer';
import SubscriptionRepository from './SubscriptionRepository';
import UserCdnRepository from './UserCdnRepository';
import ThinkAnalyticsSearchRepository from './ThinkAnalyticsSearchRepository';
import GatewayRepository from './GatewayRepository';
import ReminderRepository from './ReminderRepository';
import DeviceRepository from './DeviceRepository';
import UserIdentityRepository from './UserIdentityRepository';
import PopcornRepository from './PopcornRepository';
import EntitlementRepository from './EntitlementRepository';
import ZendeskRepository from './ZendeskRepository';
import { DiscountRepository } from './DiscountRepository';
import ChannelRepository from './ChannelRepository';
import UserRepository from './UserRepository';
import GeoLocationRepository from './GeoLocationRepository';
import ChannelSeriesHistoryRepository from './ChannelSeriesHistoryRepository';
import BookmarkRepository from './BookmarkRepository';
import ProfileRepository from './ProfileRepository';
import NotificationsRepository from './NotificationsRepository';
import MpxRepository from './MpxRepository';
import CmsRepository from './CmsRepository';
import SlpRepository from './SlpRepository';
import PaymentConfigRepository from './PaymentConfigRespository';
import LearnActionRepository from './LearnActionRepository';
import ThinkAnalyticsRepository from './ThinkAnalyticsRepository';
import AuthRepository from './AuthRepository';
import CustomConfigurationRepository from './CustomConfigurationRepository';
import UserRegistrationRepository from './UserRegistrationRepository';
import CMSCarouselRepository from './CMSCarouselRepository';
import StreamHarnessRepository from './StreamHarnessRepository';
import RewardRepository from './RewardRepository';
import BigScreenCmsRepository from './BigScreenCmsRepository';

const intializeRepositories = (container: Container) => {
    container.register(DI.REPOSITORIES.IAuthRepository, {
        useClass: AuthRepository,
    });
    container.register(DI.REPOSITORIES.IBookmarkRepository, {
        useClass: BookmarkRepository,
    });
    container.register(DI.REPOSITORIES.ICmsRepository, {
        useClass: CmsRepository,
    });
    container.register(DI.REPOSITORIES.IChannelRepository, {
        useClass: ChannelRepository,
    });
    container.register(DI.REPOSITORIES.IChannelSeriesHistoryRepository, {
        useClass: ChannelSeriesHistoryRepository,
    });
    container.register(DI.REPOSITORIES.IDeviceRepository, {
        useClass: DeviceRepository,
    });
    container.register(DI.REPOSITORIES.IDiscountRepository, {
        useClass: DiscountRepository,
    });
    container.register(DI.REPOSITORIES.IEntitlementRepository, {
        useClass: EntitlementRepository,
    });
    container.register(DI.REPOSITORIES.IGeoLocationRepository, {
        useClass: GeoLocationRepository,
    });
    container.register(DI.REPOSITORIES.IGatewayRepository, {
        useClass: GatewayRepository,
    });
    container.register(DI.REPOSITORIES.ILearnActionRepository, {
        useClass: LearnActionRepository,
    });
    container.register(DI.REPOSITORIES.IMpxRepository, {
        useClass: MpxRepository,
    });
    container.register(DI.REPOSITORIES.INotificationsRepository, {
        useClass: NotificationsRepository,
    });
    container.register(DI.REPOSITORIES.IPopcornRepository, {
        useClass: PopcornRepository,
    });
    container.register(DI.REPOSITORIES.IProfileRepository, {
        useClass: ProfileRepository,
    });
    container.register(DI.REPOSITORIES.IPaymentConfigRepository, {
        useClass: PaymentConfigRepository,
    });
    container.register(DI.REPOSITORIES.IReminderRepository, {
        useClass: ReminderRepository,
    });
    container.register(DI.REPOSITORIES.ISubscriptionRepository, {
        useClass: SubscriptionRepository,
    });
    container.register(DI.REPOSITORIES.ISlpRepository, {
        useClass: SlpRepository,
    });
    container.register(DI.REPOSITORIES.IThinkAnalyticsRepository, {
        useClass: ThinkAnalyticsRepository,
    });
    container.register(DI.REPOSITORIES.IThinkAnalyticsSearchRepository, {
        useClass: ThinkAnalyticsSearchRepository,
    });
    container.register(DI.REPOSITORIES.IUserCdnRepository, {
        useClass: UserCdnRepository,
    });
    container.register(DI.REPOSITORIES.IUserIdentityRepository, {
        useClass: UserIdentityRepository,
    });
    container.register(DI.REPOSITORIES.IUserRepository, {
        useClass: UserRepository,
    });
    container.register(DI.REPOSITORIES.IZenDeskRepository, {
        useClass: ZendeskRepository,
    });
    container.register(DI.REPOSITORIES.ICustomConfigurationRepository, {
        useClass: CustomConfigurationRepository,
    });
    container.register(DI.REPOSITORIES.IUserRegistrationRepository, {
        useClass: UserRegistrationRepository,
    });
    container.register(DI.REPOSITORIES.ICMSCarouselRepository, {
        useClass: CMSCarouselRepository,
    });
    container.register(DI.REPOSITORIES.IStreamHarnessRepository, {
        useClass: StreamHarnessRepository,
    });
    container.register(DI.REPOSITORIES.IRewardRepository, {
        useClass: RewardRepository,
    });
    container.register(DI.REPOSITORIES.IBigScreenCmsRepository, {
        useClass: BigScreenCmsRepository,
    });
};

export { intializeRepositories };
